/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// Mku
exports.getMkuPagedList = function (postData, callback) {// 分页获取MKU分页列表
    api.post('/goods/mku/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getGoodsManualList = function (params, callback) {      // 获取商品手册列表
    api.get('/goods/manual/list/by/goodsId')
    .params(params)
    .done(callback)
    .go();
};

exports.getGoodsCatTrees = function (postData, callback) {// 获取商品中的分类列表
    api.post('/goods/cat/list/by/context')
    .data(postData)
    .done(callback)
    .go();
};

exports.getGoodsBrandList = function (postData, callback) {// 获取商品中的品牌列表
    api.post('/goods/brand/list/by/context')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goods.js
// module id = 239
// module chunks = 0